'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return actionsFn[action.type] ? actionsFn[action.type]({ state: state, action: action }) : reducer(state, action);
};

exports.loadReport = loadReport;
exports.loadRecipientReport = loadRecipientReport;
exports.getLinks = getLinks;
exports.downloadReport = downloadReport;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadReducer = (0, _loadReducer2.default)('report', {
  report: { action: 'load' },
  recipientReport: { action: 'load' },
  getLinks: {},
  downloadReport: {}
}); /* Reports redux reducer and action creators */

var constantsByKey = loadReducer.constantsByKey,
    reducer = loadReducer.reducer;


var initialState = (0, _extends3.default)({}, loadReducer.initialState);

var actionsFn = {};

actionsFn.RESET = function () {
  return initialState;
};

function loadReport(_ref) {
  var projectId = _ref.projectId;

  var data = { projectId: projectId };
  return {
    types: constantsByKey.report,
    promise: function promise(client) {
      return client.post('project_wa/getProjectStats', { data: data });
    },
    projectId: projectId
  };
}

function loadRecipientReport(_ref2) {
  var projectId = _ref2.projectId,
      recipientId = _ref2.recipientId;

  var data = { projectId: projectId, recipientId: recipientId };
  return (0, _extends3.default)({
    types: constantsByKey.recipientReport,
    promise: function promise(client) {
      return client.post('project_wa/getRecipientStats', { data: data });
    }
  }, data);
}

function getLinks(projectId) {
  var data = { projectId: projectId };
  return {
    types: constantsByKey.getLinks,
    promise: function promise(client) {
      return client.post('/project_wa/downloadRecipientLinks', { data: data });
    },
    projectId: projectId
  };
}

function downloadReport(projectId) {
  var data = { projectId: projectId };
  return {
    types: constantsByKey.downloadReport,
    promise: function promise(client) {
      return client.post('/project_wa/downloadReport', { data: data });
    },
    projectId: projectId
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/report.js
// module id = 360
// module chunks = 1